export const getHeaders = (csrfToken?: string): Record<string, string> => {
	const headers = {};
	if (csrfToken) {
		headers['x-csrf-token'] = csrfToken;
	}
	return headers;
};
